import React from "react";
import { Link, Redirect } from "react-router-dom";
import "./VenueAdminLayout.scss";
import { ApplicationContext } from "ApplicationContext"
import usesFeatures from 'usesFeatures'

import requests from "request";

import User from "User";
import Icon from "Icon"
import VenueSelector from "VenueSelector";
import LanguageSelector from "LanguageSelector"

class Navigation extends React.Component {
  static contextType = ApplicationContext
  constructor (props) {
    super(props)
    this.state = {}
  }

  renderNavItem = (text, link, icon) => {
    const path = window.location.pathname
    const isActive = path == link || (link != "/" && path.includes(link))
    return(
      <li className={`${isActive ? "is-active" : "" }`}>
        <Link to={link} className={`${isActive ? "is-active" : "" }`}>
          <Icon icon={icon} className="sidebar-svg" />
          { text }
        </Link>
      </li>
    )
  }

  render() {
    if (this.state.logOut) return <Redirect to="/login" />
    const { user, venue, t } = this.props
    const { canUse } = this.context.CurrentUserContext
    const isStoreLimited = user?.storeLimited
    return(
      <div className="main-sidebar is-bordered pt-4">
        <div className="sidebar-inner">
          <ul className="icon-menu">
            { !isStoreLimited && this.renderNavItem(t("simple.stores"), "/stores", "store") }
            { !isStoreLimited && this.renderNavItem(t("simple.categories"), "/categories", "tags") }
            { !isStoreLimited && venue?.kdsEnabled && this.renderNavItem("Kitchen Stations", "/kitchen-stations", "utensils") }
            { !isStoreLimited && this.renderNavItem(t("simple.products"), "/products", "box-open") }
            { !isStoreLimited && this.renderNavItem(t("simple.discounts"), "/discounts", "percent") }
            { !isStoreLimited && this.renderNavItem("Gratuities", "/gratuities", "hand-holding-usd") }
            { !isStoreLimited && this.renderNavItem(t("simple.orders"), "/orders", "shopping-cart") }
            { this.renderNavItem(t("simple.reports"), "/reports", "chart-line") }
            { !isStoreLimited && this.renderNavItem(t("simple.terminals"), "/terminals", "cash-register") }
            { !isStoreLimited && this.renderNavItem("API Keys", "/api-keys", "key") }
            { !isStoreLimited && this.renderNavItem("Integrations", "/integrations", "plug") }
            { !isStoreLimited && initialState.account?.isCustomerDataEnabled &&
              this.renderNavItem(t("simple.customerData"), "/customers", "users")
            }
            { !isStoreLimited && this.renderNavItem("Employees", "/employees", "user-friends") }
            { this.renderNavItem("Prepaid Credits", "/prepaid_credits", "credit-card") }
            { !isStoreLimited && this.renderNavItem("Payouts", "/payouts", "money-bill-wave") }
          </ul>
        </div>
      </div>
    )
  }
}

export default usesFeatures(["translation"], Navigation)
